import styled from 'styled-components';

import * as mx from 'core/styles/mixins';
import * as vr from 'core/styles/variables';
import { FONT_NAMES } from 'core/styles/fonts';

export const ErrorSummaryContainer = styled.div`
	background-color: ${vr.formSummaryBackgroundColor};
	border: 2px solid ${vr.formSummaryBorderColor};
	border-radius: ${vr.formfieldBorderRadius};
	padding: 15px 20px;
	margin-bottom: 20px;

	h3 {
		margin: 0 0 10px;
		font-size: 20px;
		font-weight: 500;
		font-family: ${FONT_NAMES.GOTHAM_ROUNDED_BOOKED};
		color: ${vr.formSummaryTextColor};
		line-height: 1.3;
	}

	${mx.bp('l')`
		margin-bottom: 40px;
	`}
`;

export const ErrorSummaryLink = styled.a`
	cursor: pointer;
	text-decoration: none;

	&:hover,
	&:focus {
		text-decoration: underline;
	}

	&:focus {
		${mx.mimicFocus}
	}

	ul {
		margin: 0;
	}
`;

export const ErrorSummaryList = styled.ul`
	list-style-type: none;
	margin: 0;
	padding: 0;

	/* Set twice here so it overrides both the default
	hyperlink color as well as the default li::before dash */
	&,
	${ErrorSummaryLink} {
		color: ${vr.formSummaryTextColor};
	}

	${ErrorSummaryLink} {
		strong {
			font-weight: 500;
		}
	}
`;
